export function getAccount(state) {
  return state.account
}

export function isWebSocketConnected (state) {
  return state.webSocketConnected
}



// WEBPACK FOOTER //
// ./vuex/getters.js